/**
 * SACP UI login-route fix — pure resolver for the SuperAdmin OTP-auth base URL.
 *
 * SuperAdmin auth is mounted at `/api/v1/superadmin/auth/*` (verified against staging OpenAPI).
 * The env sometimes provides REACT_APP_SUPERADMIN_API_BASE as the bare API host (no
 * `/api/v1/superadmin` suffix), which previously produced `<host>/auth/login` → 404. This
 * normaliser guarantees the correct prefix whether the env carries the suffix or not, and never
 * double-appends. It does NOT affect tenant/Business/Customer auth or the `/api/v1/super-admin/*`
 * owner-control namespace.
 */
export const resolveSuperAdminAuthBase = (env = process.env) => {
  const raw = (env.REACT_APP_SUPERADMIN_API_BASE
    || env.REACT_APP_API_BASE
    || env.REACT_APP_BACKEND_URL
    || '').replace(/\/+$/, '');
  return /\/api\/v1\/superadmin$/.test(raw) ? raw : `${raw}/api/v1/superadmin`;
};
